import { DropDownConstantsFactory } from './../../../../../../base/shared/syncfusion/dropdown-constants-factory';
import { ImportConfigurationFileFormType } from './../configuration-form-file-form-type';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EnumTranslationService } from './../../../../../../base/services/enum-translation.service';
import { ImportConfigurationEditFormsCoordinatorService } from '../../import-configuration-edit-forms-coordinator.service';
import { Component, ChangeDetectorRef, AfterViewChecked, OnInit } from '@angular/core';
import { ExportInterfaceConfigurationDecimalSeparator, ExportInterfaceConfigurationTextFormat, ImportConfigurationClientAccessType, ImportConfigurationTransferType, ImportConfigurationType, ImportFileFormat, NavisionImportTemplate } from 'src/app/base/models/models.swagger.generated';
import { TranslateModule } from '@ngx-translate/core';
import { YesNoGroupButtonComponent } from '../../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { ButtonGroupComponent } from '../../../../../../base/shared/button-group/button-group.component';
import { NgClass } from '@angular/common';
import { AppErrorMessagesComponent } from '../../../../../../base/error-messages/app-error-messages.component';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { EnumDropDownListComponent } from "../../../../../../base/shared/enum-drop-down-list/enum-drop-down-list.component";

@Component({
    selector: 'app-file-general',
    templateUrl: './file-general.component.html',
    styleUrls: ['./file-general.component.scss'],
    imports: [ReactiveFormsModule, DropDownListModule, AppErrorMessagesComponent, NgClass, ButtonGroupComponent, YesNoGroupButtonComponent, TranslateModule, EnumDropDownListComponent]
})
export class FileGeneralComponent implements OnInit, AfterViewChecked {


  public get configurationFormFile(): FormGroup<ImportConfigurationFileFormType> {
    return this.formsCoordinationService.configurationFormFile;
  }

  public get transferType(): ImportConfigurationTransferType {
    return this.formsCoordinationService.configurationFormGeneral.controls.transferType.value;
  }

  public get canSendResponse(): boolean {
    if (this.formsCoordinationService.configurationFormGeneral.controls.type.value === ImportConfigurationType.Template ||
      this.formsCoordinationService.configurationFormGeneral.controls.clientAccessType.value === ImportConfigurationClientAccessType.Global) {
      return false;
    }
    return this.transferType === ImportConfigurationTransferType.Email ||
      this.transferType === ImportConfigurationTransferType.FTPClient ||
      this.transferType === ImportConfigurationTransferType.SFTPServer ||
      this.transferType === ImportConfigurationTransferType.REST;
  }

  public NavisionImportTemplate = NavisionImportTemplate;

  public enumDropdownSettings = DropDownConstantsFactory.createNumericEnumDropdownSettings();
  public fileFormats = this.enumTranslateService.translateNumericEnum(ImportFileFormat, 'i18n.domain.import-configuration.enums.file-format.', [ImportFileFormat.Acodis, ImportFileFormat.XLS, ImportFileFormat.EDIFACT]);
  public decimalSeperators = this.enumTranslateService.translateNumericEnum(ExportInterfaceConfigurationDecimalSeparator, 'i18n.domain.import-configuration.enums.decimal-seperator.');

  ImportFileFormat = ImportFileFormat;
  TextFormat = ExportInterfaceConfigurationTextFormat;
  ImportConfigurationTransferType = ImportConfigurationTransferType;
  
  constructor(
    public formsCoordinationService: ImportConfigurationEditFormsCoordinatorService,
    private enumTranslateService: EnumTranslationService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.configurationFormFile.controls.fileFormat.valueChanges.subscribe(() => {
      this.formsCoordinationService.configurationFormFile.controls.fieldAssignments.setValue([]);
      if (this.configurationFormFile.controls.fileFormat.value === ImportFileFormat.EDIFACT || this.configurationFormFile.controls.fileFormat.value === ImportFileFormat.PDF) {
        this.formsCoordinationService.configurationFormFile.controls.possibleSources.setValue([]);
      }
      if (this.configurationFormFile.controls.fileFormat.value !== ImportFileFormat.PDF) {
        this.formsCoordinationService.completeFieldAssignments();
      }

      this.formsCoordinationService.setValidatorsForFileConfigForm();
    });

    if (!this.canSendResponse) {
      this.configurationFormFile.controls.sendResponse.setValue(false);
    }
    this.formsCoordinationService.configurationFormGeneral.controls.transferType.valueChanges.subscribe(() => {
      if (!this.canSendResponse) {
        this.configurationFormFile.controls.sendResponse.setValue(false);
      }
    });
  }

  public ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

}
